import React, { useMemo } from 'react';

import { IonCol, IonGrid, IonRow } from '@ionic/react';

import { useScreenState } from 'components/Screen';
import { useSummary } from 'scenes/DashboardPage/data';

import SummaryCard from './components/SummaryCard';
import SummaryCardSkeleton from './components/SummaryCardSkeleton';
import './index.css';

const Widgets = () => {
  const screenState = useScreenState();
  const { data, isRefetching, isLoading, isSuccess, isError, error }: any =
    useSummary({
      filters: screenState.filters,
    });
  const isEmpty = useMemo(() => !data, []);

  const renderComponentFn = useMemo(() => {
    switch (true) {
      case isError:
        return ({ label, value, metricType, precision }: any) => (
          <SummaryCard
            label={label}
            value={value}
            metricType={metricType}
            precision={precision}
            isRefetching={isRefetching}
            isError={isError}
            error={error}
          />
        );
      case isLoading:
        return () => <SummaryCardSkeleton />;
      case isEmpty:
        return ({ label, value, metricType, precision }: any) => (
          <SummaryCard
            label={label}
            value={value}
            metricType={metricType}
            precision={precision}
            isRefetching={isRefetching}
            isError={isError}
            error={error}
          />
        );
      case isSuccess:
        return ({ label, value, metricType, precision }: any) => (
          <SummaryCard
            label={label}
            value={value}
            metricType={metricType}
            precision={precision}
            isRefetching={isRefetching}
            isError={isError}
            error={error}
          />
        );
      default:
        return () => null;
    }
  }, [isLoading, isRefetching, isEmpty, isSuccess, isError, data, error]);

  return (
    <IonGrid className={'ion-padding-horizontal widgets'}>
      <IonRow>
        {Array(4)
          .fill(null)
          .map((_, index) => (
            <IonCol key={index} size={'6'} className={'flex'}>
              {renderComponentFn({
                label: data?.[index]?.label,
                value: data?.[index]?.value,
                metricType: data?.[index]?.metricType,
                precision: data?.[index]?.precision,
              })}
            </IonCol>
          ))}
      </IonRow>
    </IonGrid>
  );
};

export default Widgets;
